<template lang="pug">
  .main-container.registry-search(ref="root")
    h1 {{ __('Gear Registry Search') }}
    h4 {{ __('Search by Name') }}
    RogueInput(label="Name" v-model="name")
    RogueButton.reg-search-btn(color="green" @click="find({name})") {{__('Search by Name')}}
    h4 {{ __('Search by Email') }}
    RogueInput(label="Email" type="email" v-model="email")
    RogueButton.reg-search-btn(color="green" @click="find({email})") {{__('Search by Email')}}
    h4 {{ __('Search by Registry ID') }}
    RogueInput(label="Gear Registry ID" v-model="id")
    RogueButton.reg-search-btn(color="green" @click="find({id})") {{__('Search by ID')}}
    .registries(ref="resultsEl" v-if="status === ''")
      h4.center.no-results(v-if="!results || !results.length") {{ __('No registries found.') }}
      h2(v-else) {{__('Results: ') }}
      .registry-result(v-for="result in (results || [])")
        h4 {{result.name}}
        .date {{formatDate(result.date)}}
        p {{result.description}}
        .recipient(v-for="recipient in result.recipients") {{ __('Recipient: {name}', {name: (recipient.firstName || '') + ' '+(recipient.lastName || '')}) }}
        rogue-link.reg-link(:to="'/registry/'+result.urlKey") {{ __('View Registry') }}
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { useHead } from '@unhead/vue'
import { reset } from '@/js/helpers/validate-fns'
import metadata from '@/js/helpers/metadata'
import { formatDate } from '@/js/helpers/date'
import { useRogue } from '@/js/services/Rogue'

type RegistrySearchResult = {
  urlKey: string,
  name: string,
  date: string,
  description?: string,
  recipients?: { firstName?: string, lastName?: string }[],
}

type RegistrySearchQuery = {
  name?: string,
  email?: string,
  id?: string,
}

const rogue = useRogue()

useHead(metadata({ title: rogue.__('Gear Registry Search') }, rogue))

const root = ref<HTMLElement>()
const resultsEl = ref<HTMLElement>()

const results = ref<RegistrySearchResult[] | null>(null)
const status = ref('empty')
const name = ref('')
const email = ref('')
const id = ref('')

async function find(query: RegistrySearchQuery) {
  if (root.value) {
    reset(root.value)
  }
  status.value = 'loading'

  try {
    results.value = await rogue.fetch<RegistrySearchResult[]>('/svc_list/lists/registries/search', 'post', query)
    status.value = ''
  } catch (e) {
    results.value = null
    status.value = ''
  }
  if (status.value === '') {
    resultsEl.value?.scrollIntoView()
  }
}
</script>
<style lang="scss" scoped>

.reg-search-btn {
  margin-bottom: $space-m;
}

.no-results {
  margin: $space-xl 0;
}

.registry-search {
  margin-top: $space-m;
  margin-bottom: $space-l;
}

.registries {
  margin-top: $space-xxl;
}

.registry-result {
  padding: $space-s;
  border: 1px solid $color-gray-light;
  border-radius: $radius-default;
  margin-bottom: $space-s;
}

.date {
  font-size: $size-xs;
  margin-bottom: $space-m;
  color: $color-black-light;
}

.reg-link {
  margin-top: $space-s;
  display: block;
}
</style>
